import { Card } from "@/libraries/design/components";
import { useLocalizedHref } from "@/libraries/web-framework";
import { RichTextComponent } from "@/templates/agile-hub/src/sections/components/body-text";

export interface UniformCardProps {
    alignment?: "start" | "center";
    eyebrow?: string;
    title?: string;
    titleAs?: "h2" | "h3" | "h4" | "h5" | "p";
    body?: string;
    richText?: string;
    linkText?: string;
    linkUrl?: string;
    imageUrl?: string;
    imageAlt?: string;
    iconUrl?: string;
    iconSize?: "x-small" | "small" | "medium" | "large";
}

const getBodyText = (props: UniformCardProps) => {
    if (!props.body && !props.richText) {
        return undefined;
    }

    if (props.richText) {
        return <RichTextComponent name={null} text={props.richText} />;
    }

    return props.body;
};

const UniformCard = (props: UniformCardProps) => {
    const localizedHref = useLocalizedHref(props.linkUrl?.toString() ?? "");

    return (
        <Card
            align={props.alignment}
            eyebrow={props.eyebrow ? props.eyebrow : undefined}
            title={props.title ? props.title : undefined}
            titleAs={props.titleAs}
            body={getBodyText(props)}
            callToAction={
                props.linkUrl && props.linkText
                    ? {
                          text: props.linkText,
                          href: localizedHref
                      }
                    : undefined
            }
            image={
                props.imageUrl
                    ? {
                          image: {
                              src: props.imageUrl,
                              alt: props.imageAlt ?? ""
                          }
                      }
                    : undefined
            }
            icon={
                props.iconUrl
                    ? {
                          linkedIcon: {
                              url: props.iconUrl,
                              size: props.iconSize
                          }
                      }
                    : undefined
            }
        />
    );
};

export default UniformCard;
